import {useState,useEffect} from "react";
import "./Search.css";
import { useNavigate } from 'react-router-dom';
import LoaderImg from '../../assets/loading-gif.gif';

const Search = () => {

   
    const [country,setCountry] = useState("");
    const [company,setCompany] = useState("");
    const [hind,setHind] = useState("");
    const [companyId,setCompanyId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [disabled,setDisabled] = useState(true);
    const [error,setError] = useState(false);
    const [loader, setLoader] = useState(false);

    const selectChangeHanler = (e) => {
        // console.log(e.target.value);
        setCountry(e.target.value);
        setDisabled(false);
    }

    const companyNameHandler = (e) => {
        // console.log(e.target.value);
        setCompany(e.target.value);
        setError(false)
        document.querySelector(".companyListing").style.opacity = "1";
 
    }

    const onCompanyClickHandler = (e) => {
        setCompany(e.target.innerHTML);
        setCompanyId(e.target.id);
        document.querySelector(".companyListing").style.opacity = "0";
    }

    useEffect(()=>{
        const fetchData = async () => {
            try {
              setLoader(true);
              const response = await fetch(`http://ec2-34-227-92-25.compute-1.amazonaws.com:8080/TegPoc/search?countries=${country}&name=${company}`,
              {
                mode: 'cors',
                headers: {
                    'Access-Control-Allow-Origin':'*'
                }
            });
              const json = await response.json();
              const data = json.companies
              setHind(data)
            //   for (let i = 0; i < data.length; i++) {
            //     setHind(data[i].name);
            //     console.log(data[i].name);
            //   }
            //   localStorage.setItem('cdata',JSON.stringify(json));
            //   navigate('/listing');
            } catch (error) {
              console.log(error);
            } finally {
                setLoader(false);
            }
          };
          
          company.length >= 3 && fetchData();
    },[company,setCompany])


    const navigate = useNavigate();

    const onSubmitHandler = (e) => {
        e.preventDefault();
    
        setIsLoading(true);
    
        const fetchData = async () => {
          try {
            const response = await fetch(`http://ec2-34-227-92-25.compute-1.amazonaws.com:8080/TegPoc/companies?company_id=${companyId}`,
            {
                mode: 'cors',
                headers: {
                    'Access-Control-Allow-Origin':'*'
                }
            });
            const json = await response.json();
            // console.log(json); 
            !json.report && setError(true);
            localStorage.setItem('cdata',JSON.stringify(json));
            json.report && navigate('/listing');
          } catch (error) {
            console.log(error);
          } finally {
            setIsLoading(false);
          }
        };
    
        fetchData();
      };



    return(
        <div className="search">
            <div className="container">
                <div className="form-inner">
                    <form onSubmit={onSubmitHandler}>
                        <h3>Search your company</h3>
                        <div className="input-wrap">
                            <select onChange={selectChangeHanler}>
                                <option value = "">Select Country</option>
                                <option value = "US">United States</option>
                                <option value = "CA">Canada</option>
                            </select>
                        </div>
                        <div className="input-wrap">
                            { loader == true ? <img src={LoaderImg} className="loaderImage"/> : ""}
                            {
                                disabled == true ?
                                <input disabled value={company} onChange={companyNameHandler} placeholder="Enter company name"/>:
                                <input value={company} onChange={companyNameHandler} placeholder="Enter company name"/>
                            }
                            <ul className="companyListing">
                            {
                                hind && hind.map(hind=>{
                                    return(
                                        <li id={hind.id} onClick={onCompanyClickHandler} key={hind.id}>{hind.name}</li>
                                    )
                                })
                            }
                        </ul>
                        </div>
                        <button>Search</button>
                        {error == true && <p className="error">This company has no data</p>}
                    </form>
                </div>
            </div>
            {isLoading && <div className="Loader">Loading data...</div>}
        </div>
    );
}

export default Search;